import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import "../../styles/Contact.css";

const Contact = () => {
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData(formRef.current);
    const name = fd.get("name")?.trim();
    const email = fd.get("email")?.trim();
    const subject = fd.get("subject")?.trim();
    const message = fd.get("message")?.trim();
    const phone = fd.get("phone")?.trim();

    // simple front-end validation
    if (!name || !email || !subject || !message) {
      setStatus({ ok: false, msg: "Please fill all required fields." });
      return;
    }

    setSending(true);
    setStatus(null);
    try {
      const result = await emailjs.send(
        "service_563r6ai",
        "template_z77oc5k",
        {
          to_email: "woodworks@icityinc.in",
          name,
          email,
          subject,
          message,
          phone,
        },
        "pWjqu3sICwUYUp95M"
      );
      if (result.status === 200) {
        setStatus({ ok: true, msg: "Message sent successfully. We’ll get back shortly." });
        formRef.current.reset();
      } else {
        setStatus({ ok: false, msg: "Could not send message. Please try again." });
      }
    } catch (err) {
      setStatus({ ok: false, msg: "Something went wrong. Please try again later." });
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="ct-wrap" style={{ minHeight: "90vh", padding: "100px 20px" }} aria-labelledby="ct-title">
      <div className="ct-container">
        <header className="ct-hero">
          <h2 id="ct-title" className="ct-heading">Let’s Build Together…</h2>
          <p className="ct-subtitle">
            Ready to start a custom woodworking project? Get in touch today for a consultation and free estimate.
          </p>
        </header>

        <div className="ct-grid">
          {/* Left: modern form card */}
          <form ref={formRef} className="ct-card ct-form" onSubmit={onSubmit} noValidate>
            <div className="ct-card-head">
              <div className="ct-chip">
                <i className="bi bi-chat-text" aria-hidden="true" />
                <span>Send us a Message</span>
              </div>
              <span className="ct-badge" aria-hidden="true">1</span>
            </div>

            <div className="ct-row-2">
              <div className="ct-field">
                <label htmlFor="name">Name<span className="req">*</span></label>
                <input id="name" name="name" type="text" placeholder="Full name" required />
              </div>
              <div className="ct-field">
                <label htmlFor="email">Email<span className="req">*</span></label>
                <input id="email" name="email" type="email" placeholder="name@example.com" required />
              </div>
            </div>

            <div className="ct-row-2">
              <div className="ct-field">
                <label htmlFor="phone">Phone</label>
                <input id="phone" name="phone" type="tel" placeholder="+91 90000 00000" />
              </div>
              <div className="ct-field">
                <label htmlFor="subject">Subject<span className="req">*</span></label>
                <input id="subject" name="subject" type="text" placeholder="Project subject" required />
              </div>
            </div>

            <div className="ct-field">
              <label htmlFor="message">Message<span className="req">*</span></label>
              <textarea id="message" name="message" rows="4" placeholder="Tell us about your project…" required />
            </div>

            <button type="submit" className="ct-btn" disabled={sending}>
              {sending ? <><i className="bi bi-arrow-repeat spin" /> Sending…</> : <><i className="bi bi-send" /> Send Message</>}
            </button>

            {/* status message */}
            {status && (
              <div className={`ct-status ${status.ok ? "ok" : "err"}`} role="status">
                {status.msg}
              </div>
            )}
          </form>

          {/* Right: contact info column */}
          <div className="ct-info-col">
            <div className="ct-card ct-info">
              <div className="ct-info-icon"><i className="bi bi-telephone-fill" aria-hidden="true" /></div>
              <div className="ct-info-body">
                <div className="ct-info-label">Phone</div>
                <div className="ct-info-text">+91 72000 73335</div>
              </div>
            </div>

            <div className="ct-card ct-info">
              <div className="ct-info-icon"><i className="bi bi-envelope-fill" aria-hidden="true" /></div>
              <div className="ct-info-body">
                <div className="ct-info-label">Email</div>
                <div className="ct-info-text">woodworks@icityinc.in</div>
              </div>
              <a className="ct-info-cta" href="mailto:woodworks@icityinc.in" aria-label="Email us">
                <i className="bi bi-arrow-up-right" />
              </a>
            </div>

            <div className="ct-card ct-info ct-info-map">
              <div className="ct-info-icon">
                <i className="bi bi-geo-alt-fill" aria-hidden="true" />
              </div>

              <div className="ct-info-body">
                <div className="ct-info-label">Address</div>
                <div className="ct-info-text">
                  Om Ganesh Nagar, Vadavalli,<br />
                  Coimbatore, Tamil Nadu 641041.
                </div>
              </div>

              {/* Embedded Google Map */}
              <iframe
                title="Location map of Om Ganesh Nagar, Vadavalli"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.2021164451608!2d76.9049462740908!3d11.023457054590514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85f1d25389f75%3A0x9d93fcc49fcc15c6!2sIcity%20Inc!5e0!3m2!1sen!2sin!4v1758094681023!5m2!1sen!2sin"
                width="150"
                height="80"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />


            </div>


            <div className="ct-card ct-info">
              <div className="ct-info-icon"><i className="bi bi-clock-fill" aria-hidden="true" /></div>
              <div className="ct-info-body">
                <div className="ct-info-label">Hours</div>
                <div className="ct-info-text">Mon–Sat: 9:00 AM – 6:00 PM<br /> Sun: Closed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
